import { Injectable, EventEmitter } from '@angular/core';
import { IPlatformToolHandler } from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { MagicLinkModel, TabModel } from '@shared/models/platform-tool-models';
import { ActivatedRoute, Router } from '@angular/router';
import { PlatformCommand, ContentScope } from '@shared/commands/command-base';
import { Store, select } from '@ngrx/store';
import { IDac6ReporterState } from '../store/reducers/dac6-reporter.reducer';
import { ParticleService } from '@core/services/particle.service';
import { ParticleCacheService } from '@core/services/particle-cache.service';
import { ParticleState } from '@shared/store/reducers/particle.reduer';
import { SnackBarService } from '@core/services/snack-bar.service';
import { DialogService } from '@shared/services/dialog-service';
import { CommandService } from '@core/services/command.service';
import { PlatformSidebarState } from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import { IQueryState } from '@shared/store/reducers/query.reducer';
import { CollaborationState } from '@features/task-manager/collaboration/store/collaboration.reducer';
import { FormBuilder } from '@angular/forms';
import { Dac6ReporterApiService } from './dac6-reporter.service';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';
import {Dynamic_Grid_Data_Request_Parameters, User_Specefic_Grid_Filter} from '@shared/store/actions/virtual-grid.actions';
import { BreadcrumbModel } from '@shared/models/breadcrumb.model';
import {Observable, of, Subject} from 'rxjs';
import { BasketModel } from '@shared/models/common.models';
import { Configuration } from '@shared/models/configuration';
import { BasketProvider } from '@shared/models/basket-provider';
import { take, takeUntil } from 'rxjs/operators';
import {
  ArrangeMentsDeleteCommand,
  CreateArrangementFromExistingCaseCommand,
  ArchiveSingleCaseCommand,
  UnarchiveCaseCommand,
  SaveSelectedArrangementsInLeftSideOfTheTransferboxCommand,
  CopyOrMoveForFilingCommand,
  SyncProjectEntityToCompanyCommand,
  UpdateArrangementCommand,
  PreArrangeMentsDeleteCommand,
  CreatePreArrangementFromExistingCaseCommand,
  UpdatePreArrangementCommand,
  ExportCaseCommand, CopyFilingFromExistingCaseCommand
} from '../commands/dac6-reporter.command';
import { FilingTypes } from '@shared/constants/FilingTypes';
import { ArrangementFields, FilingStages, CommonFields } from '@shared/constants/ArrangementConstants';
import { FilingPeriod } from '@shared/constants/FilingPeriod';
import { ArrangementBasketHelper } from '../components/arrangement-content/ArrangementBasketHelper';
import { SetActivityFeedAction, SetCurrentHelpNoteAction } from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import { DialogModel } from '@shared/models/dialog.model';
import { CreateChatConversationCommand } from '@features/task-manager/collaboration/store/collaboration.command';
import { CreateChatConversationAction } from '@features/task-manager/collaboration/store/collaboration.action';
import { ConversationComponentName } from '@features/task-manager/collaboration/store/collaboration.constants';
import { getQueryResponse } from '@shared/store/selectors/query.selector';
import { QueryProvider } from '@shared/queries/query-provider';
import { BasketId } from '../Fields';
import { UpdateFieldDefinitionCommand } from '@shared/commands/update-field-definition.command';
import { ParticleConfig } from '@features/particle-config';
import { CleanWorkflowDataAction } from '@features/workflow/store/workflow.actions';
import { FileStoreCommonService } from '@features/file-manager/services/file-store-common.service';
import { Dac6RoutingPlatformCommandHelper } from '@shared/components/platform-tool/routing-platform-command-helpers/dac6-routing-command-helper';
import { RootDynamicComponentHelper } from '@shared/helpers/root-dynamic-component-helper';
import { PlatformSidebarService } from '@shared/components/platform-sidebar/store/platform-sidebar.service';
import {FileManagementService} from '@core/services/file-management.service';

@Injectable({
  providedIn: 'root',
})

export class PlatformToolDac6CaseHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter();
  activatedRoute?: ActivatedRoute;
  metaData?: any;

  sourceType = 'Arrangement'; // will get From Magic Link
  currentSelectedItems: string[];
  flag: boolean;
  deleteDisabled: boolean;
  hasNoExtraTab = true;
  breadcrumbs: BreadcrumbModel[];
  breadcrumbs$: Observable<BreadcrumbModel[]>;
  tabs: any[];
  selectedTab: any;
  actions: any[];
  filterId: string;
  endpoint = 'Dac6Api';
  filedPeriod = 'notfiled';
  private config: any;
  inputForm: any;
  fieldHistorySourceType = 'Dac6-Field-History';
  showArchived: boolean;
  selectedBasket: BasketModel;
  showAnnouncement = false;
  announcementContent = '';
  unSubscribe$ = new Subject<void>();


  constructor(private router: Router,
     private store: Store<IDac6ReporterState>,
    private particleService: ParticleService,
    private particleCacheService: ParticleCacheService,
    private particleStore: Store<ParticleState>,
    private snackBarService: SnackBarService,
    private dialogService: DialogService,
    private commandService: CommandService,
    private platformSidebarStore: Store<PlatformSidebarState>,
    private queryState: Store<IQueryState>,
    private collaborationStore: Store<CollaborationState>,
    private formBuilder: FormBuilder,
    private sideBarService: PlatformSidebarService,
    private fileStoreCommonService: FileStoreCommonService,
    private dac6ReporterApiService: Dac6ReporterApiService,
    private fileManagementService: FileManagementService,
    private fuseSplashScreenService: FuseSplashScreenService) {
    this.invalidateSubject = new InvalidateSubject();
    this.showArchived = false;
  }
  destroy(): void {
  }
  executeCommand(command: PlatformCommand) {
    console.log(command);
    switch (command.name) {
      case 'ShowArchivedCommand':
        this.showArchivedChanged(command);
        break;
      case 'WorkflowCleanupCommand':
        this.cleanupWorkFlow(command);
        break;
      case 'BasketChangedCommand':
        this.changeBasket(command.fieldValues['CurrentBasket']);
        break;
      case 'ExportOverviewCommand':
        this.exportOverview();
        return;
      default:
        this.executeCommandToApi(command);
    }
  }
  changeBasket(Basket: BasketModel) {
    // this.selectedBasket = Basket;
    // console.log('[Basekt Change] in basket');
    // console.log(this.selectedBasket.id);
    if (this.magicLinkModel.fieldValues['CurrentBasket'].id !== Basket.id) {
      const command = this.getCurrentCommand();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
         if (response.fieldValues['PlatformLinkModel']) {
           const payload = {
            id: 'PlatformToolContainerComponent',
            value: response.fieldValues['PlatformLinkModel']
          };
          this.magicLinkModel = response.fieldValues['PlatformLinkModel'];
          this.magicLinkModelValueChanged.emit(payload);
         }
      });
    }
  }
  getCurrentCommand() {
    const urlToken = this.router.url.split('?');
    let command = Dac6RoutingPlatformCommandHelper.getPreArrangementPlatformLinkCommand();
    command.fieldValues['QueryParameter'] = urlToken.length > 1 ? urlToken[1] : '';
    if ( this.sourceType.toLowerCase() === 'arrangement' ) {
      command = Dac6RoutingPlatformCommandHelper.getArrangementPlatformLinkCommand();
      command.fieldValues['QueryParameter'] = urlToken.length > 1 ? urlToken[1] : '';
      command.fieldValues['FILED_PERIOD'] = this.activatedRoute.snapshot.params['FILED_PERIOD'];
    } else if ( this.sourceType.toLowerCase() === 'case' ) {
      command = Dac6RoutingPlatformCommandHelper.getDac6PlatformLinkCommand('OverviewToolLinkPlatformCommand');
      command.fieldValues['QueryParameter'] = urlToken.length > 1 ? urlToken[1] : '';
    }
    return command;
  }
  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTab = selectedTab;
    this.sourceType = this.selectedTab.id;
    if (this.magicLinkModel.fieldValues['WorkflowTool'] === 'Export') {
      this.handleExport();
    } else if (this.magicLinkModel.fieldValues['WorkflowTool'] === 'Import') {
      this.magicLinkModel.fieldValues['Parameters'] = {
        'ImportSampleExcelTemplateName': this.magicLinkModel.fieldValues['ImportSampleExcelTemplateName'],
        'TOOL_NAME': this.magicLinkModel.fieldValues['TOOL_NAME']
      };
    }
    this.sideBarService.showSidebarIcon('Details');
    let helpNoteId = 'dac6-arrangement';
    if(this.sourceType.startsWith('PreArrangement'))
    {
      helpNoteId='dac6-pre-arrangement';
    } else if (this.sourceType.toLowerCase() == 'case') {
      helpNoteId = 'dac6-overview' ;
    }
    const helpNoteObj = this.getHelpNoteObject(helpNoteId);
    this.platformSidebarStore.dispatch(new SetCurrentHelpNoteAction(helpNoteObj));
  }

  private getHelpNoteObject(helpNoteId) {
    let helpNoteObj = {};
    helpNoteObj['helpNoteId'] = helpNoteId;
    return helpNoteObj;
  }

  private handleExport() {
    let includeArchives = false;
    const selectedSourceType = this.magicLinkModel.fieldValues['ExportSelectedSourceType'];
    const notSelectedSourceType = this.magicLinkModel.fieldValues['ExportNotSelectedSourceType'];
    const selected = Configuration.getSmartGridConfig(selectedSourceType);
    const notSelected = Configuration.getSmartGridConfig(notSelectedSourceType);
    //
    const filingType = this.activatedRoute.snapshot.params['filingType'];
    if (filingType) {
      selected.Parameters['FILING_TYPE'] = filingType;
      notSelected.Parameters['FILING_TYPE'] = filingType;
    }
    if (this.activatedRoute.snapshot.params['includeArchives']) {
      includeArchives = this.activatedRoute.snapshot.params['includeArchives'];
      selected.Parameters['INCLUDE_ARCHIVES'] = includeArchives;
      notSelected.Parameters['INCLUDE_ARCHIVES'] = includeArchives;
    }
  }

  valueChanged(event) {
    console.log(event);
    if (event.fieldDefinition && event.fieldDefinition.key === 'CaseId') {
      this.router.navigateByUrl(`dac6-reporter/${this.magicLinkModel.fieldValues['ToolId']}/${event.item.type.includes('Case') ? 'case' : 'detail'}/${event.item.id}`);
      return;
    }
    if (event.fieldDefinition && event.fieldDefinition.key === 'Suggested_Hallmarks') {
      this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, '500px', '500px').subscribe();
      return;
    }
    if(event.fieldDefinition && event.fieldDefinition.key === 'Workflow') {
      this.startWorkflow(event.item);
      return ;
    }
    if (event.action) {
      switch (event.action.id) {
        case 'Open':
          this.router.navigateByUrl(`dac6-reporter/${this.magicLinkModel.fieldValues['ToolId']}/${event.item.type.includes('Case') ? 'case' : 'detail'}/${event.item.id}`);
          break;
        case 'OpenHallmarkQuestion':
          this.navigateToDetailViewerTab(event.fieldDefinition, event.item);
          break;
        case 'Edit':
          this.edit(event);
          break;
        case 'CopyCase':
          this.copyCase(event);
          break;
        case 'itemClick':
          this.handleItemClick(event);
          break;
        case 'OpenCaseFolder':
          this.sendViewDocumentActivityCommand(event);
          this.navigateToCaseFolder(event);
          break;
        case 'Start Conversation':
          this.startConversationActivity(event);
          this.getChatForThisCase(event);
          break;
        case 'ArchiveCase':
          this.archiveSingle(event.item.cells['CaseGUID'].value);
          break;
        case 'UnarchiveCase':
          this.unarchiveCase(event.item.cells['CaseGUID'].value);
          break;
        case 'Move to Arrangements': // pre arrangement Sepcific
          if (!event.item.isReadOnly) {
            this.router.navigateByUrl(`dac6-reporter/pre-arrangement/prearrangement-to-arrangement/${event.item.id}`);
          }
          break;
        case 'Delete':
          this.executeCaseDeleteCommand(event);
          break;
        case 'Copy':
          this.copyCase(event);
          break;
        case 'ViewActivity':
          this.trackCaseActiviy(event);
          break;
        //region Arrangement
        case 'MoveToMonthly':
          this.copyOrMove(event.item, FilingTypes.Dac6MonthlyFiling, false, 'dac6-reporter/arrangement/filing/monthly', event.action.id);
          break;
        case 'MoveToOther':
          this.copyOrMove(event.item, FilingTypes.Dac6OtherFiling, false, 'dac6-reporter/arrangement/filing/other', event.action.id);
          break;
        case 'MoveToQuarterly':
        case 'CopyToQuarterly':
          if (event.item.cells[ArrangementFields.FilingStages] && event.item.cells[ArrangementFields.FilingStages].value === FilingStages.CopiedToQuarterly) {
            const message = 'This arrangement is already copied to Quarterly Filing. You cannot copy this again.';
            this.dialogService.showDialogMessage('Message', message);
          } else if (event.item.cells[ArrangementFields.FilingStages] && event.item.cells[ArrangementFields.FilingStages].value === FilingStages.CopiedToAnnually) {
            this.dialogService.showDialogMessage('Message', 'This arrangement is already copied to Annual Filing. You cannot copy this to Quarterly Filing.');
          } else {
            this.copyOrMove(event.item, FilingTypes.Dac6QuarterlyFiling, event.action.id === 'CopyToNextQuarter', `dac6-reporter/arrangement/filing/${FilingPeriod.QuarterlyId(new Date(Date.now()))}`, event.action.id);
          }
          break;
        case 'CopyToNextQuarter':
          if (event.item.cells[ArrangementFields.FilingStages].value === FilingStages.CopiedToNextQuarter) {
            this.dialogService.showDialogMessage('Message', 'This arrangement is already copied to next quarter. You cannot copy this again.');
          } else {
            const qId = FilingPeriod.QuarterlyId(new Date(Date.now()));
            if (qId === event.item.cells[CommonFields.FiledPeriodId].value) {
              let message = 'This arrangement can be copied after ending of current quarter.';
              if (event.item.cells['MarketableArrangement'] && event.item.cells['MarketableArrangement'].value) {
                message = 'Additional reporting of marketable arrangements must be completed  every 3 months.';
              }
              this.dialogService.showDialogMessage('Message', message);
            } else {
              this.copyOrMove(event.item, FilingTypes.Dac6QuarterlyFiling, event.action.id === 'CopyToNextQuarter', `dac6-reporter/arrangement/filing/${qId}`, event.action.id);
            }
          }
          break;
        case 'MoveToYearly':
        case 'CopyToYearly':
          if (event.item.cells[ArrangementFields.FilingStages] && event.item.cells[ArrangementFields.FilingStages].value === FilingStages.CopiedToQuarterly) {
            this.dialogService.showDialogMessage('Message', 'This arrangement is already copied to Quarterly Filing. You cannot copy this to Annual Filing.');
          } else if (event.item.cells[ArrangementFields.FilingStages] && event.item.cells[ArrangementFields.FilingStages].value === FilingStages.CopiedToAnnually) {
            this.dialogService.showDialogMessage('Message', 'This arrangement is already copied to Annual Filing. You cannot copy this to again.');
          } else {
            this.copyOrMove(event.item, FilingTypes.Dac6YearlyFiling, event.action.id === 'CopyToNextYear', `dac6-reporter/arrangement/filing/${FilingPeriod.YearlyId(new Date(Date.now()).getFullYear())}`, event.action.id);
          }
          break;
        case 'CopyToNextYear':
          if (event.item.cells[ArrangementFields.FilingStages].value === FilingStages.CopiedToNextYear) {
            this.dialogService.showDialogMessage('Message', 'This arrangement is already copied to next year. You cannot copy this again.');
          } else {
            const yId = FilingPeriod.YearlyId(new Date(Date.now()).getFullYear());
            if (yId === event.item.cells[CommonFields.FiledPeriodId].value) {
              this.dialogService.showDialogMessage('Message', 'This arrangement can be copied after ending of current year.');
            } else {
              this.copyOrMove(event.item, FilingTypes.Dac6YearlyFiling, event.action.id === 'CopyToNextYear', `dac6-reporter/arrangement/filing/${yId}`, event.action.id);
            }
          }
          break;
        case 'CreateDueDate':
          if (ArrangementBasketHelper.isCreateDueDateValid(event.item)) {
            this.createDueDate(event.item, event.action.id);
          } else {
            const errorMessage = ArrangementBasketHelper.dueDateCreationInvalidMessage();
            this.dialogService.showDialogMessage('Message', errorMessage);
          }
          break;
        case 'AssignTransactions':
          if (event.item.cells[ArrangementFields.CountryToReport] && event.item.cells[ArrangementFields.ReportingEntity] && event.item.cells[ArrangementFields.ReportingDueDate]) {
            this.router.navigateByUrl('dac6-reporter/transactions');
          } else {
            this.dialogService.showDialogMessage('Message', 'Please select Country to Report, Reporting Entity & Reporting Date before assigning transaction.');
          }
          break;
        case 'LaunchWorkflow' :
          if(event.item.cells['Workflow']){
            this.startWorkflow(event.item);
          } else {
            this.dialogService.showDialogMessage('Message', 'Please select WorkFlow');
          }
          break;
        case 'CancelWorkflow' :
          if(event.item.cells['Workflow']){
            this.cancelWorkflow(event);
          } else {
            this.dialogService.showDialogMessage('Message', 'Please select WorkFlow');
          }
          break;
        //endregion
      }
    }
    console.log(event);
  }
  private cancelWorkflow(event: any) {
    const item = event.item;
    const command = this.magicLinkModel.additionalCommands[event.action.id];
    if (command) {
      // command.fieldValues['AuditStageId'] = item.id;
      command.fieldValues['ItemId'] = item.id;
      command.fieldValues['SourceType'] = item.type;
      this.executeCommand(command);
    }
  }

  private startWorkflow(item) {
    const command = this.magicLinkModel.additionalCommands['Workflow'];
    command.fieldValues['ItemId'] = item.id;
    command.fieldValues['SourceType'] = item.type;
    const commandHandler = RootDynamicComponentHelper.getComponent('StartWorkFlowCommandHandler');
    if (commandHandler) {
      command.fieldValues['FieldKey'] = 'Workflow';
      if (item.cells['Workflow'] && item.cells['Workflow'].value) {
        command.fieldValues['Workflow'] =  item.cells['Workflow'].value;
      }
      commandHandler.executeCommand(command, this, null);
    }
  }

  sendViewDocumentActivityCommand(event){
    const viewDocumentCommand = new PlatformCommand('ViewDocumentActivityCommand', 'Dac6Api');
    const sourceKey = BasketProvider.getRootSourceKeyBySourceType(event.item.type);
    viewDocumentCommand.fieldValues['SourceType'] = sourceKey;
    viewDocumentCommand.fieldValues['CaseId'] = event.item.id;
    this.commandService.executePlatformCommand(viewDocumentCommand).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
      },
      error => {
        console.error('Failed to basket manage section', error);
      });
  }

  executeCaseDeleteCommand(event){
    let command = new ArrangeMentsDeleteCommand([event.item.id]);
    if(this.sourceType === 'PreArrangement'){
      command = new PreArrangeMentsDeleteCommand([event.item.id]);
    }
    this.commandService.executeCommand(command).subscribe(state => {
      if (state) {
        this.invalidateSubject.invalidate();
        this.snackBarService.showInformation(`${this.sourceType} Deleted Successfully`);
      }
    });
  }

  export() {
    this.router.navigate(['export'], {
      relativeTo: this.activatedRoute,
      queryParams: {
        includeArchives: this.showArchived
      }
    });
  }

  private trackCaseActiviy(event: any) {
    this.platformSidebarStore.dispatch(new SetActivityFeedAction({type: 'ReferenceCode', id: event.item.cells['ReferenceCode'].value, title: event.item.cells['CaseId'].value, isDefault: false, isUserAction: true}));
  }
  //



  archiveSingle(caseGuid: string) {
    const dialogModel = DialogModel.create('Archive Case',
      'ArchiveDialogComponent',
      {}, '500px', '490px', false);
    dialogModel.okCaption = 'Archive';
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(data => {
      if (data.action === 'OK') {
        console.log(data.data.input['comment']);
        const command = new ArchiveSingleCaseCommand(caseGuid, data.data.input['comment']);
        this.fuseSplashScreenService.show();
        this.commandService.executeCommand(command).subscribe(state => {
          this.invalidateSubject.invalidate();
          this.fuseSplashScreenService.hide();
        });
      }
    });
  }

  unarchiveCase(caseGuid: string) {
    const message = 'You can unarchive this Case if you need to make additional edits, or if it was archived by mistake. Please ensure that any associated Tasks and Reports are updated and re-opened as required.';
    const question = 'Are you sure you want to unarchive this DAC6 Case?';
    this.dialogService.showConfirmDialog('Unarchive', 'Unarchive', 'Cancel', message, question).subscribe(data => {
      if (data.action === 'OK') {
        const command = new UnarchiveCaseCommand(caseGuid);
        this.fuseSplashScreenService.show();
        this.commandService.executeCommand(command).subscribe(state => {
          this.invalidateSubject.invalidate();
          this.fuseSplashScreenService.hide();
        });
      }
    });
  }
  sendShowArchivedActivityCommand() {
    const showArchivedCommand = new PlatformCommand('ShowArchivedCommand', 'Dac6Api');
    const sourceKey = BasketProvider.getRootSourceKeyBySourceType(this.sourceType);
    showArchivedCommand.fieldValues['SourceType'] = sourceKey;
    showArchivedCommand.fieldValues['IsArchived'] = this.showArchived;
    // viewDocumentCommand.fieldValues[sourceKey+"Id"] = event.item.id;
    this.commandService.executePlatformCommand(showArchivedCommand).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
      },
      error => {
        console.error('Failed to basket manage section', error);
      });
  }

  import() {
    this.router.navigateByUrl('dac6-reporter/arrangement/import');
    // this.router.navigate(['import'], {relativeTo: this.activatedRoute});
  }

  startConversationActivity(event) {
    const startConversationCommand = new PlatformCommand('OpenConversationActivityCommand', 'Dac6Api');
    const sourceKey = BasketProvider.getRootSourceKeyBySourceType(event.item.type);
    startConversationCommand.fieldValues['SourceType'] = sourceKey;
    // viewDocumentCommand.fieldValues[sourceKey+"Id"] = event.item.id;
    startConversationCommand.fieldValues['CaseId'] = event.item.id;
    this.commandService.executePlatformCommand(startConversationCommand).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
      },
      error => {
        console.error('Failed to basket manage section', error);
      });
  }

  getChatForThisCase(event) {
    const sourceInfoDictionary = {
      'sourceInfoDictionary': {
        CaseGuid: event.item.cells['CaseGUID'].value,
        caseId: event.item.cells['CaseId'].displayText
      }
    };
    console.log('event:', event);
    const createChatConversationCommand = new CreateChatConversationCommand(
      '[COMPANY_ID]-chat',
      `${event.item.cells['CaseId'].displayText}`,
      true,
      0,
      'DAC6',
      [],
      true,
      event.item.cells['CaseGUID'].value,
      sourceInfoDictionary
    );
    createChatConversationCommand.scope = ContentScope.Company;
    this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
  }

  navigateToCaseFolder(event: any) {
    console.log('navigateToCaseFolder', event);
    if (event.action && event.action.tags.length) {
      let relativePath = event.action.tags[0];
      const caseId = event.item.cells['CaseId'].displayText;
      relativePath = relativePath.replace('[CASE_ID]', caseId);
      console.log('rellativePath', relativePath);
      // const relativeUrl$ = this.queryState.pipe(select(getQueryResponse, 'UrlByRelativePath'))
      //   .pipe(take(2));
      // relativeUrl$.subscribe(state => {
      //   console.log('RelativeUrl', state);
      //   if (state) {
      //     this.router.navigateByUrl(state);
      //   }
      // });

      // QueryProvider.invokeQuery(this.queryState, 'UrlByRelativePath', {'[RELATIVE_PATH]': relativePath});
      this.fileStoreCommonService.navigateToClientFolderUsingRelativepath(relativePath);

    }
  }

  createFilingFromArrangement(arrangement: any, filingType: string, actionid = null) {
    if (arrangement.cells['IsFilingCreated'] && arrangement.cells['IsFilingCreated'].value === true) {
      this.router.navigateByUrl(`dac6-reporter/filing/${filingType}`);
      return;
    }
    const selectionKey = 'create-filing-from-arrangement';
    const preCommand = new SaveSelectedArrangementsInLeftSideOfTheTransferboxCommand(selectionKey, arrangement.id);
    this.commandService.executeCommand(preCommand).subscribe(prestate => {
      if (prestate) {
        this.openTransferboxToCreateFiling(arrangement, filingType, selectionKey, actionid);
      }
    });
  }

  openTransferboxToCreateFiling(arrangement: any, filingType: string, selectionKey: string, actionid = null) {
    const metaData = {
      arrangement: arrangement,
      filingType: filingType,
      selectionKey: selectionKey,
      actionId: actionid
    };
    ArrangementBasketHelper.createFilinngStepper(metaData, this.router, this.commandService, this.dialogService, this.fuseSplashScreenService);
  }


  createDueDate(item: any, actionid = null) {
    this.createFilingFromArrangement(item, item.cells.Tag.value.toString().toLowerCase(), actionid);
  }

  copyOrMove(arrangement: any, filingType: string, nextIteration: boolean, redirectUrl: string, actionid = null) {
    const isCopy = this.isCopyArrangement(arrangement, nextIteration);
    const selectionKey = this.getSelectionKeyForCopyOrMove(isCopy);
    const preCommand = new SaveSelectedArrangementsInLeftSideOfTheTransferboxCommand(selectionKey, arrangement.id);
    this.commandService.executeCommand(preCommand).subscribe(prestate => {
      if (prestate) {
        this.openTranseFerboxToCopyOrMove(arrangement.id, filingType, nextIteration, redirectUrl, selectionKey, isCopy, actionid);
      }
    });
  }

  isCopyArrangement(arrangement: any, nextIteration: boolean): boolean {
    const isCopy = nextIteration || (arrangement.cells[ArrangementFields.Tag].value !== 'NotFiled' && arrangement.cells[ArrangementFields.Tag].value !== 'NotFiledArchived');
    return isCopy;
  }

  getSelectionKeyForCopyOrMove(isCopy: boolean): string {
    return isCopy ? 'copy-arrangement' : 'move-arrangement';
  }

  openTranseFerboxToCopyOrMove(arrangementId: string, filingType: string, nextIteration: boolean, redirectUrl: string, selectionKey: string, isCopy: boolean, actionid = null) {
    const input = {
      ['SELECTION_KEY']: selectionKey,
      ['ITEM_ACTION_ID']: actionid
    };
    const dialogModel = DialogModel.create('Select', 'EntitySelectorDialogComponent', {
      filterId: arrangementId,
      filterTemplateId: 'dac6-copy-or-move-arrangement-filter',
      apiKey: 'Dac6Api',
      input: input
    });
    dialogModel.isFullscreen = true;

    this.dialogService.showOkCancelDialog(dialogModel)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe(actionState => {
        if (actionState && actionState.action === 'OK') {
          this.fuseSplashScreenService.show();
          const command = new CopyOrMoveForFilingCommand(arrangementId, filingType, nextIteration, isCopy);
          this.commandService.executeCommand(command).subscribe(state => {
            this.fuseSplashScreenService.hide();
            if (redirectUrl !== '') {
              this.router.navigateByUrl(redirectUrl);
            } else {
              this.invalidateSubject.invalidate();
            }
          }, error => {
            console.log(error);
            this.fuseSplashScreenService.hide();
          });
        }
      });

  }

  edit(event: any) {
    if (event.fieldDefinition.cellEditor === 'EntityTextCellEditor') {
      // Sync
      let command = new SyncProjectEntityToCompanyCommand(false);
      this.commandService.executeCommand(command).pipe().subscribe(commandState => {
        console.log(commandState);
        if (commandState.Payload.ConfirmationNeeded) {
          this.dialogService.showYesNoDialog('Confirm Sync', `You were working with the entities of project '${commandState.Payload.Configuration.ProjectModel.Name}'. Do you want to sync with the current project?`)
            .subscribe(state => {
              if (state.action === 'OK') {
                command = new SyncProjectEntityToCompanyCommand(true);
                this.commandService.executeCommand(command).pipe().subscribe(commandState2 => {
                  console.log(commandState2);
                  this.openEditor(event);
                });
              } else {
                this.openEditor(event);
              }
            });
        } else {
          this.openEditor(event);
        }
      });
      return;
    }
    this.openEditor(event);
  }

  public openEditor(event: any) {
    let minWidth = '1500px';
    const maxWidth = '1500px';
    if (event.fieldDefinition.key === 'ReportingEntity') {
      minWidth = '550px';
    }
    if (event.fieldDefinition.key === 'AssociateEnterprises') {
      minWidth = '760px';
      const sourceConfigKey = event.fieldDefinition.configKey;
      const config = Configuration.getSmartGridConfig(sourceConfigKey);
      config.Parameters['ID'] = event.item.id;
      this.particleCacheService.saveUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, sourceConfigKey, config.Parameters);
    }
    if (event.fieldDefinition.key === 'CountryToReport') {
      minWidth = '600px';
    }
    if (event.fieldDefinition.dataType === 'Attachment') {
      minWidth = '550px';
      if (event.fieldDefinition.metaData['DirectoryPath']) {
        event.fieldDefinition.metaData['DirectoryPath'] = event.fieldDefinition.metaData['DirectoryPath'].replace('[CASE_ID]', event.item.cells['CaseId'].value);
      }
    }
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth, this.sourceType, this.fieldHistorySourceType).subscribe(state => {
      console.log('After Edit', state);
      if (state.action === 'OK') {
        this.saveFieldDefinition(state.data.input.fieldDefinition, event.fieldSection);
        const item = {id: event.item.id, fieldValues: {}};
        const value = event.item.cells[event.fieldDefinition.key].value;
        item.fieldValues[event.fieldDefinition.key] = value;
        // if (event.item.cells[event.fieldDefinition.key].displayText) {
        //   item.fieldValues[`Display${event.fieldDefinition.key}`] = event.item.cells[event.fieldDefinition.key].displayText;
        // }
        if (event.fieldDefinition.dataType === 'Attachment') {
          item.fieldValues[`${event.fieldDefinition.key}FileName`] = event.item.cells['fileName'];
        }
        console.log(item);
        const command = this.getUpdateCommand(item);
        const currentBasket = BasketProvider.getCurrentBasket();
        switch (currentBasket.id) {
          case BasketId.Mexico:
            command.IsHallmarkAutomatedCopy = true;
            break;
          default:
        }
        this.commandService.executeCommand(command).pipe().subscribe(commandState => {
          console.log(commandState);
          if (commandState.Payload.FieldValues[`${event.fieldDefinition.key}NoteAvailable`]) {
            this.snackBarService.showInformation(commandState.Payload.FieldValues[`${event.fieldDefinition.key}NoteAvailable`]);
          }
          this.invalidateSubject.invalidate();
        });
      }
    });
  }
  getUpdateCommand(item){
    let command = new UpdateArrangementCommand(item);
    if(this.sourceType === 'PreArrangement'){
      command = new UpdatePreArrangementCommand(item);
    }
    return command;
  }

  saveFieldDefinition(fieldDefinition: any, selectedFieldSection: any) {
    let fieldSettings = null;
    if (fieldDefinition && fieldDefinition.configKey) {
      const fieldConfig = Configuration.getSmartGridConfig(fieldDefinition.configKey);
      if (fieldConfig && fieldConfig.FieldSettings) {
        fieldSettings = fieldConfig.FieldSettings;
      }
    }
    if (fieldSettings) {
      const rootUrlKey = Configuration.getSmartGridConfig(this.sourceType).RootUrlKey;
      const url = `${Configuration.getConfig(rootUrlKey)}FieldSection/UpdateFieldDefinition`;
      const config = Configuration.getSmartGridConfig(this.sourceType);
      if (config) {
        const sourceType = config.SourceType;
        const updateFieldDefinitionCommand = new UpdateFieldDefinitionCommand([fieldDefinition], selectedFieldSection.id, ParticleConfig.ApplicationId, sourceType, true,
          url, !Configuration.getSmartGridConfig(this.sourceType).IsCompanySpecific);
        this.commandService.executeCommand(updateFieldDefinitionCommand).pipe().subscribe(commandState => {
          this.invalidateSubject.invalidate();
        });
      }
      /*      const updateUrl = `${Configuration.getConfig('Dac6Api')}Command/UpdateCaseStatus`;
       const addCaseStatusCommand = new AddCaseStatusCommand([fieldDefinition],
       updateUrl, !Configuration.getSmartGridConfig(this.sourceType).IsCompanySpecific);
       this.commandService.executeCommand(addCaseStatusCommand).pipe().subscribe(commandState => {
       this.invalidateSubject.invalidate();
       });*/
    }
  }

  private handleItemClick(event: any) {
    if (event.fieldDefinition.key === 'AssociateEnterprises') {
      this.openEditor(event);
      return;
    }
    console.log('handle click');
    const participantsId = this.formatFieldDefinitionKey(event.fieldDefinition.key);
    const url = `dac6-reporter/participants/${participantsId}/${event.item.cells['CaseId'].displayText}`;
    this.router.navigate([url]);
  }

  private formatFieldDefinitionKey(key: string) {
    return key === 'RelevantTaxpayers' ? 'relevant-taxpayers' : (key === 'Intermediaries' ? 'intermediaries' : (key === 'AssociateEnterprises' ? 'associate-enterprises' : 'other-persons'));
  }

  private copyCase(event: any) {
    const dialogModelTitle = 'Copy Case (' + event.item.cells.CaseId.displayText + ')';
    let input = this.getDialogModelInputForCopyCase(event);
    const dialogModel: DialogModel = DialogModel.create(
      dialogModelTitle,
      'CopyCaseDialogComponent',
      input,
      '600px',
      '700px',
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      console.log(res);
      if (res.action === 'OK') {
        switch (res.data.input.caseType) {
          case 'Arrangement':
            if (res.data.input.specifyField) {
              res.data.input['title'] = event.item.cells.Title.value;
              this.openSelectFieldDialog(res.data.input.selectedCase, 'arrangementmodel', 'Arrangement', res, event.item.id, res.data.input.copyCount);
            } else {
              this.addArrangementFromExistingCaseId(event.item.cells.Title.value, res.data.input.selectedCase, res.data.input.archiveExisting, res.data.input.caseIdUsedforCorrection, res.data.input.copyCount);
            }
            break;
          case 'Pre-Arrangement':
            if (res.data.input.specifyField) {
              res.data.input['title'] = event.item.cells.Title.value;
              this.openSelectFieldDialog(res.data.input.selectedCase, 'prearrangementmodel', 'PreArrangement', res, event.item.id, res.data.input.copyCount);
            } else {
              this.addPreArrangementFromExistingCaseId(event.item.cells.Title.value, res.data.input.selectedCase, res.data.input.archiveExisting, res.data.input.caseIdUsedforCorrection, res.data.input.copyCount );
            }
            break;
          case 'Filing':
            if (res.data.input.specifyField) {
              res.data.input['title'] = event.item.cells.Title.value;
              this.openSelectFieldDialog(res.data.input.selectedCase, 'filingmodel', 'Dac6MonthlyFiling', res, res.data.input.copyCount);
            } else {
              this.copyFilingFromExistingCaseCommand(res.data.input.selectedCase, res.data.input.archiveExisting, res.data.input.copyCount);
            }
            break;
        }
      }

    });
  }
  copyFilingFromExistingCaseCommand(existingCaseId: string, archiveExisting: boolean, copyCount: number, selectedFields?: string[], copyAllFields: boolean = true) {
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(new CopyFilingFromExistingCaseCommand(existingCaseId, archiveExisting, false, copyCount, selectedFields, copyAllFields)).pipe().subscribe(state => {
      this.fuseSplashScreenService.hide();
      this.router.navigateByUrl(`/dac6-reporter/filing/monthly`);
    });
  }
  getDialogModelInputForCopyCase(event){
    let inputObj = {
      'caseId': event.item.cells.CaseId.displayText,
      'caseType': this.magicLinkModel.fieldValues['CaseType'] === 'Case' ? event.item.cells.Stage.value : this.magicLinkModel.fieldValues['CaseType'],
      'disableTypeChange': true,
      'isReadOnly': event.item.isReadOnly,
      'isArcived' : event.item.cells.Archived.value};

      if(event.item.cells.FiledPeriodTitle) {
        inputObj['filedPeriodTitle'] = event.item.cells.FiledPeriodTitle.displayText;
      }
      return inputObj;
  }

  addArrangementFromExistingCaseId(title: string, existingCaseId: string, archiveExisting: boolean, caseIdForCorrection: boolean, copyCount?: number, selectedFields?: string[], copyAllFields: boolean = true) {
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(new CreateArrangementFromExistingCaseCommand(title, existingCaseId, archiveExisting, caseIdForCorrection, copyCount, selectedFields, copyAllFields)).pipe().subscribe(state => {
      this.fuseSplashScreenService.hide();
      this.router.navigateByUrl(`dac6-reporter/arrangement/detail/${state.Payload.Id}`);
    });
  }
  addPreArrangementFromExistingCaseId(title: string, existingCaseId: string, archiveExisting: boolean, caseIdForCorrection: boolean, copyCount?: number, selectedFields?: string[],  copyAllFields: boolean = true) {
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(new CreatePreArrangementFromExistingCaseCommand(title, existingCaseId, archiveExisting, caseIdForCorrection, copyCount, selectedFields, copyAllFields)).pipe().subscribe(state => {
      this.fuseSplashScreenService.hide();
      this.router.navigateByUrl(`dac6-reporter/pre-arrangement/detail/${state.Payload.Id}`);
    });
  }
  private openSelectFieldDialog(selectedCase: string, dbmodelType: string, sourceType: string, caseData: any, existingId: string, copyCount: number = 1) {
    const dialogModel: DialogModel = DialogModel.create(
      'Select Data',
      'VirtualGridDialogComponent', {sourceKey: 'Dac6-RowFieldData-Config', params: {'rowId': selectedCase, 'dbmodelType': dbmodelType, 'sourceType': sourceType}},
    );
    dialogModel.isFullscreen = true;
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        switch (sourceType) {
          case 'Arrangement':
            this.addArrangementFromExistingCaseId(caseData.data.input.title, selectedCase, caseData.data.input.archiveExisting, false, copyCount, res.data.input.selectedFields, false);
            break;
          case 'PreArrangement':
            this.addPreArrangementFromExistingCaseId(caseData.data.input.title, selectedCase, caseData.data.input.archiveExisting, false, copyCount, res.data.input.selectedFields, false);
            break;
        }
      }
    });
  }
  private navigateToDetailViewerTab(fieldDefinition, item) {
    if (item.cells[fieldDefinition.key].value !== 'Yes') {
      return ;
    }
    const fieldSectionKey = fieldDefinition.metaData['ChildHallmarkFieldSectionKey'];
    let selectedFieldSectionTabIndex = 0;
    for (let i = 0 ; i < this.tabs.length ; i++) {
      if (this.tabs[i].headerKey && this.tabs[i].headerKey === fieldSectionKey) {
        selectedFieldSectionTabIndex = i;
        break;
      }
    }
    const routingPath = `dac6-reporter/${this.magicLinkModel.fieldValues['ToolId']}/detail/${item.id}?selectedTab=${selectedFieldSectionTabIndex}`;
    this.router.navigateByUrl(routingPath);
  }
  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          } else if (commandResponse.fieldValues['Error']) {
            const duration = commandResponse.fieldValues['Error'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['Error'], duration);
          } else {
            this.invalidateSubject.invalidate();
          }
        },
        error => {
          console.error('Failed ToolBarComponent command', error);
          this.fuseSplashScreenService.hide();
          if (error && error.fieldValues && error.fieldValues['Error']) {
            const errorMessage = error.fieldValues['Error'];
            this.snackBarService.showError(errorMessage);
          }
          return of(null);
        });
    }
  }
 // Commands
  private cleanupWorkFlow(command: PlatformCommand) {
    if (this.magicLinkModel.fieldValues['WorkflowTool'] === 'Export') {
      this.store.dispatch(new CleanWorkflowDataAction(command.fieldValues['SelectedTab'].tabData['WorkFlowId']));
      this.router.navigateByUrl(command.fieldValues['SelectedTab'].tabData['ReRouteUrl']);
    }
    if (this.magicLinkModel.fieldValues['WorkflowTool'] === 'Import') {
      this.router.navigateByUrl(command.fieldValues['SelectedTab'].tabData['ReRouteUrl']);
    }
  }
  private showArchivedChanged(command: PlatformCommand) {
    this.fuseSplashScreenService.show();
    console.log('showArchivedChanged');
    this.showArchived = command.isChecked;
    this.selectedTab.tabData['SHOW_ARCHIVED'] = command.isChecked;
    const params = this.particleCacheService.getUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, this.sourceType);
    params['SHOW_ARCHIVED'] = this.showArchived;
    this.particleCacheService.saveUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, this.sourceType,params);
    this.sendShowArchivedActivityCommand();
    this.invalidateSubject.invalidate();
    this.fuseSplashScreenService.hide();
  }
  exportOverview() {
    this.fuseSplashScreenService.show();
    const filtersObject = this.particleCacheService.getUserPreferenceGridSetting(User_Specefic_Grid_Filter, this.sourceType);
    const filters = Object.values(filtersObject);
    const parametersObject = this.particleCacheService.getUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, this.sourceType);
    const command = new ExportCaseCommand(filters, parametersObject);
    this.commandService.executeCommand(command).subscribe(state => {
      if (state) {
        this.fileManagementService.downloadClientFileWithId(state.Payload).pipe().subscribe((payload: any) => {
          this.fileManagementService.openSaveFileWindow(payload, 'Cases-Overview.xlsx');
          this.fuseSplashScreenService.hide();
        }, () => {
          this.fuseSplashScreenService.hide();
        });
      }
      this.fuseSplashScreenService.hide();
    }, () => {
      this.fuseSplashScreenService.hide();
    });
  }


}
